export function calculatePositionForPopup(
  element: HTMLDivElement,
  direction: 'up' | 'down'
) {
  const { left, top, height } = element.getBoundingClientRect();

  if (direction === 'up') {
    return {
      left: left,
      top: top,
    };
  }

  return {
    left: left,
    top: top + height,
  };
}
